import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class DispatchQuoteTypesDisplayListComponent implements IController {
  dispatchQuoteTypes: any;
  isRow: any;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onRemove(type) {
    this.onChange({
      dispatchQuoteTypes: _.filter(this.dispatchQuoteTypes, (q) => {
        return q !== type
      })
    });
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('dispatchQuoteTypesDisplayList', {
    bindings: {
      dispatchQuoteTypes: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./dispatch-quote-types-display-list.html').default,
    controller: DispatchQuoteTypesDisplayListComponent
  });
